import { Chip, Paper, Popper } from "@mui/material";
import { PropTypes } from "prop-types";

const OverflowTags = ({
    getItemProps,
    hiddenItems,
    hoverTimeoutRef,
    isFilterInput,
    overflowAnchor,
    setHoveredChip,
    setOverflowAnchor,
    value,
}) => (
    <>
        <Chip
            label={`+${hiddenItems.length}`}
            sx={{
                alignItems: "center",
                display: "flex",
                fontSize: isFilterInput ? "10px" : "12px",
                fontWeight: 500,
                height: isFilterInput ? "10px" : 26,
                justifyContent: "center",
                minWidth: isFilterInput ? "10px" : "auto",
                paddingX: isFilterInput ? 0.5 : 1,
                width: isFilterInput ? "10px" : "auto",
            }}
            onMouseEnter={(e) => {
                if (hoverTimeoutRef.current) clearTimeout(hoverTimeoutRef.current);
                setOverflowAnchor(e.currentTarget);
            }}
            onMouseLeave={() => {
                hoverTimeoutRef.current = setTimeout(() => {
                    setHoveredChip(null);
                    setOverflowAnchor(null);
                }, 1000);
            }}
        />

        <Popper
            anchorEl={overflowAnchor}
            open={Boolean(overflowAnchor)}
            placement="bottom-start"
            style={{ zIndex: 1300 }}
            onMouseEnter={() => {
                if (hoverTimeoutRef.current) clearTimeout(hoverTimeoutRef.current);
            }}
            onMouseLeave={() => {
                hoverTimeoutRef.current = setTimeout(() => {
                    setHoveredChip(null);
                    setOverflowAnchor(null);
                }, 1000);
            }}
        >
            <Paper
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 1,
                    justifyContent: "space-between",
                    maxHeight: "40vh",
                    minWidth: 150,
                    overflowY: "auto",
                    p: 1,
                }}
            >
                {hiddenItems.map((item) => (
                    <Chip
                        key={item?.value}
                        {...getItemProps({ index: value.indexOf(item) })}
                        label={item?.label || ""}
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            minHeight: 32,
                        }}
                    />
                ))}
            </Paper>
        </Popper>
    </>
);

OverflowTags.propTypes = {
    getItemProps: PropTypes.func.isRequired,
    hiddenItems: PropTypes.array.isRequired,
    hoverTimeoutRef: PropTypes.object.isRequired,
    isFilterInput: PropTypes.bool,
    overflowAnchor: PropTypes.object,
    setHoveredChip: PropTypes.func.isRequired,
    setOverflowAnchor: PropTypes.func.isRequired,
    value: PropTypes.array.isRequired,
};

export default OverflowTags;
